import scrollSmoothly from 'jump.js'
import { Controller } from 'stimulus'
import 'nodelist-foreach-polyfill'

export default class extends Controller {
  connect() {
    document.querySelectorAll('a[href^="#"]').forEach((element) => {
      element.addEventListener('click', this.onclick)
    })
  }

  onclick(event) {
    const offset = document.querySelector('.Header').offsetHeight * -1

    const isModifiedEvent = (event) => {
      return event.ctrlKey || event.shiftKey || event.altKey || event.metaKey
    }

    const focusWithoutScroll = (element) => {
      const x = window.scrollX || window.pageXOffset
      const y = window.scrollY || window.pageYOffset
      element.focus()
      window.scrollTo(x, y)
    }

    const focusForcibly = (element, options = {}) => {
      if (options.preventScroll) {
        focusWithoutScroll(element)
      } else {
        element.focus()
      }
      if (document.activeElement !== element) {
        element.tabIndex = -1
        if (options.preventScroll) {
          focusWithoutScroll(element)
        } else {
          element.focus()
        }
      }
    }
    if (event.button === 0 && !isModifiedEvent(event)) {
      history.pushState({}, '', event.currentTarget.hash)
      const targetElement = document.querySelector(event.currentTarget.hash)
      scrollSmoothly(targetElement, {
        duration: 600,
        offset: offset,
      })
      focusForcibly(targetElement, { preventScroll: true })
      event.preventDefault()
    }
  }
}